// extracted by mini-css-extract-plugin
module.exports = {"txtWrapper":"Description-module--txtWrapper--2t2rC"};